import type { IncomeInsuranceRootLogic } from 'models';
import { type Context, createContext } from 'react';

export const RootContext = createContext(
  {} as IncomeInsuranceRootLogic,
) as Context<IncomeInsuranceRootLogic>;
